'use client'
import { ArrowRight } from '@/components/svg/arrow-right/arrow-right'
import { Slider } from '@/components/v2/atoms/slider/slider'
import { SupplierReviewItem } from '@/components/v3/unique/supplier/supplier-reviews/supplier-review-item/supplier-review-item'
import s from './supplier-review-slider.module.scss'
import { CSS_BREAKPOINTS_V2, SUPPLIER_SECTION_ID } from '@/constants'

export type Review = {
  name: string
  message: string
  rating?: number
  date?: string
}

type Props = {
  reviews: Review[]
}

export const SupplierReviewSlider = ({ reviews }: Props) => {
  return (
    <div className={s.slider} id={SUPPLIER_SECTION_ID.REVIEWS}>
      <Slider
        renderNavigation={(slideLeft, slideRight) => {
          const navigationVisible = reviews.length > 1
          return (
            <div className={s.topWrapper}>
              <h2 className={s.title}>Reviews</h2>
              {navigationVisible && (
                <div className={s.sliderControls}>
                  <button
                    onClick={slideLeft}
                    className={s.sliderArrow}
                    aria-label="Previous review"
                  >
                    <ArrowRight
                      iconColor="#131313"
                      svgProps={{
                        style: {
                          transform: 'rotate(180deg) translateY(-1.5px)',
                        },
                        width: 16,
                        height: 16,
                      }}
                    />
                  </button>
                  <button
                    onClick={slideRight}
                    className={s.sliderArrow}
                    aria-label="Next review"
                  >
                    <ArrowRight
                      iconColor="#131313"
                      svgProps={{
                        style: {
                          transform: 'translateY(1.5px)',
                          width: 16,
                          height: 16,
                        },
                      }}
                    />
                  </button>
                </div>
              )}
            </div>
          )
        }}
        ignoreDefaultBreakpoints
        options={{
          slides: {
            spacing: 0,
            origin: 0,
            perView: 1.25,
          },
          breakpoints: {
            [`(min-width: ${CSS_BREAKPOINTS_V2.tablet})`]: {
              slides: {
                spacing: 16,
                perView: 2.3,
              },
            },
            [`(min-width: ${CSS_BREAKPOINTS_V2.desktopS})`]: {
              slides: {
                spacing: 28,
                perView: 2,
              },
            },
          },
        }}
      >
        {reviews.map((review, index) => (
          <SupplierReviewItem
            name={review.name}
            message={review.message}
            rating={review.rating}
            date={review.date}
            key={index}
          />
        ))}
      </Slider>
    </div>
  )
}
